module.exports = __webpack_public_path__ + "img/chalet.8071d768.svg";